// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payments-container {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tpadding: 1rem;\r\n}\r\n", "",{"version":3,"sources":["webpack://src/components/Payments/styles.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;AACd","sourcesContent":[".payments-container {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tpadding: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
